import script from "./record-ai-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./record-ai-upload.vue?vue&type=script&setup=true&lang=js"

import "./record-ai-upload.vue?vue&type=style&index=0&id=19dcb910&lang=scss"

const __exports__ = script;

export default __exports__